import type { ImpactArtifactsBlock } from "@mw/shared/payload-types";
import type { ReactNode } from "react";

import { useCallback, useState } from "react";

import { hasRenderableDialogContent } from "./ImpactArtifactsGallery.utils";

type Artifacts = ImpactArtifactsBlock["artifacts"];

interface UseImpactArtifactsDialogProps {
  artifactDialogContents: Array<ReactNode | null>;
  artifacts: Artifacts;
  onBeforeOpen: () => void;
}

export function useImpactArtifactsDialog({
  artifactDialogContents,
  artifacts,
  onBeforeOpen,
}: UseImpactArtifactsDialogProps) {
  const [selectedArtifactIndex, setSelectedArtifactIndex] = useState<number | null>(null);
  const [isArtifactDialogOpen, setIsArtifactDialogOpen] = useState(false);
  const selectedArtifactDialogContent =
    selectedArtifactIndex === null ? null : (artifactDialogContents[selectedArtifactIndex] ?? null);
  const selectedArtifact =
    selectedArtifactIndex === null || !hasRenderableDialogContent(selectedArtifactDialogContent)
      ? null
      : (artifacts[selectedArtifactIndex] ?? null);

  const openArtifactDialog = useCallback(
    (index: number) => {
      if (!hasRenderableDialogContent(artifactDialogContents[index])) {
        return;
      }

      onBeforeOpen();
      setSelectedArtifactIndex(index);
      setIsArtifactDialogOpen(true);
    },
    [artifactDialogContents, onBeforeOpen],
  );

  return {
    isArtifactDialogOpen,
    openArtifactDialog,
    selectedArtifact,
    selectedArtifactDialogContent,
    setIsArtifactDialogOpen,
  };
}
